import PropTypes from 'prop-types';
import { CustomIcon } from '$src/components/CustomIcon';

import './index.less';

export default function UserIcon() {
  return (
    <>
      <div className="user-dropdown-trigger">
        <div className="user-dropdown-trigger-indicator">
          <CustomIcon type="regular" name="icon-user.svg" />
        </div>
      </div>
    </>
  );
}

UserIcon.propTypes = {
  user: PropTypes.shape({
    user_id: PropTypes.number,
  }),
};
